<template>
    <div>
      <div >

      </div>
      <div>

      </div>
    </div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module-1/index.vue